import { useRouteError } from 'react-router';

const ErrorPage = () => {
  const { error } = useRouteError();
  console.error(error?.message);

  return (
    <div
      id='error-page'
      className='flex flex-col h-screen items-center justify-center'
    >
      <h1 className='font-bold text-2xl'>Not found</h1>
      <p>Sorry, an unexpected error has occurred.</p>

      <a
        href='/'
        className='underline mt-12'
      >
        Go back
      </a>
    </div>
  );
};

export default ErrorPage;
